/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Rename_Too_LongInputs */

const vi_irrigation_rename_too_long = /** @type {(inputs: Irrigation_Rename_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên tối đa 120 ký tự.`)
};

/**

* @param {Irrigation_Rename_Too_LongInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_rename_too_long = /** @type {((inputs?: Irrigation_Rename_Too_LongInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Rename_Too_LongInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_rename_too_long(inputs)
});